import { render, staticRenderFns } from "./ServiceOrderRepairContactComponent.vue?vue&type=template&id=2a91a921&"
import script from "./ServiceOrderRepairContactComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderRepairContactComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderRepairContactComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports